import React from "react";
import { authSelector } from "../redux/features/auth/authSlice";
import { useSelector } from "react-redux";

function useAuth() {
  const auth = useSelector(authSelector);

  if (auth?.accessToken && auth?.user) {
    return {
      isAuth: true,
      accessToken: auth.accessToken,
      user: auth.user,
    };
  } else {
    return {
      isAuth: false,
      accessToken: null,
      user: null,
    };
  }
}

export default useAuth;
